import { User } from '../src/interfaces/user'
import { API_BASE_URL, X_API_KEY } from './api'
import * as Sentry from '@sentry/browser'

const fetchUsers = async (): Promise<User[]> => {
  try {
    const response = await fetch(`${API_BASE_URL}/all/full`, {
      headers: {
        'x-api-key': X_API_KEY,
      },
    })

    if (!response.ok) {
      throw new Error('Failed to fetch users')
    }

    const data = await response.json()

    if (!data.users) {
      throw new Error('Invalid response format - no users property')
    }

    const sortedUsers = data.users.sort(
      (a: User, b: User) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
    )

    return sortedUsers
  } catch (error) {
    Sentry.captureException(error)
    throw error
  }
}

export { fetchUsers }
